import qs from 'qs';
import { get } from 'lodash-es';
import { EMPTY_OBJECT } from '@is24at/react-constants';
import { universalReplaceHistory } from 'utils/utils';
import prettyUrlsResultList from 'core/prettyUrlsResultList';
import { htmlMetaGenerated } from 'components/HtmlMeta/modules/htmlMeta';
import { fetchRealtors, fetchRealtorsFailure } from './resultList';
import generateHtmlMeta from './resultListHtmlMetaTransformer';
import byTotalHits from './selectors/totalHits';

const parseQueryStringWithoutPrefix = (queryString: any) =>
  qs.parse(queryString, {
    ignoreQueryPrefix: true,
  });

const fetchRealtorsAndGenerateHtmlMeta = async ({
  store: { dispatch, getState },
  location,
  match: { params },
  helpers,
  history: { replace } = EMPTY_OBJECT,
}: any) => {
  try {
    const {
      builtLocation,
      decodedQuery,
      shouldRedirectToPrettyURL,
      shouldRedirectToBaseURL,
    } = await prettyUrlsResultList.analyzeUrlGet({
      params,
      location,
    });
    if (shouldRedirectToBaseURL) {
      return dispatch(fetchRealtorsFailure());
    }

    if (shouldRedirectToPrettyURL) {
      return universalReplaceHistory(
        replace,
        get(helpers, 'redirectIntent'),
        prettyUrlsResultList.locationToPrettyUrlWithQs({
          ...location,
          ...builtLocation,
        }),
      );
    }

    const targetQuery = {
      ...parseQueryStringWithoutPrefix(location.search),
      ...decodedQuery,
    };
    await fetchRealtors(targetQuery, getState())(dispatch);

    const totalHits = byTotalHits(getState());
    const htmlMeta = generateHtmlMeta({
      searchQuery: targetQuery,
      pathname: location.pathname,
      totalHits,
    });

    return dispatch(htmlMetaGenerated(htmlMeta));
  } catch (ignore) {
    return dispatch(fetchRealtorsFailure());
  }
};

export default fetchRealtorsAndGenerateHtmlMeta;
